import React, { FC } from 'react';
import styled from 'styled-components';
import media from '../../constants/media';
import theme from '../../constants/theme';
import { getCurrentCulture } from '../../helpers/url/urlHelpers';
import useGet from '../../hooks/useGet';
import IArticleListItem from '../../interfaces/articles/articleListItem';
import { INews } from '../../interfaces/umbracoNodes/contentSlices';
import { ContentContainer } from '../base/contentContainer/contentContainer';
import RichTextTitle from '../base/richTextTitle';
import TextLinkWithArrow from '../textLinkWithArrow';
import NewsSlider from './newsSlider';

const NUMBER_OF_ARTICLES_TO_SHOW = 8;
const FEATURED_TAG = 'featured';

const ContentContainerStyled = styled(ContentContainer)`
	${media.desktopSmall`
		clip-path: inset(-100vw 0 -100vw -24px);
	`};
`;

const NewsContainer = styled.div`
	margin-block: 150px 32px;
	display: flex;
	flex-direction: column;
	font-family: ${theme.fonts.Arimo};
`;

const TitleAndLinkContainer = styled.div`
	${media.desktopSmall`
		display: flex;
		align-items: center;
		justify-content: space-between;
	`}
`;

const LinkContainer = styled.div`
	margin-top: 46px;

	${media.desktopSmall`
		margin-top: 0;
		margin-left: 32px;
	`}
`;

interface Props {
	news: INews;
}

const News: FC<Props> = ({ news }) => {
	const url = `/api/articles?culture=${getCurrentCulture()}&pageSize=10000`;
	const { response, loading, error } = useGet(url);
	if (error || loading || !response || response.data.Items.length === 0) {
		return null;
	}

	let filteredArticles: IArticleListItem[] = response.data.Items;

	if (news.Values.CategoryFilter) {
		filteredArticles = response.data.Items.filter(
			(article: IArticleListItem) => article.Category === news.Values.CategoryFilter
		);
	}

	if (news.Values.FeaturedFilter) {
		filteredArticles = filteredArticles.filter(article => article.Tags?.includes(FEATURED_TAG));
	}

	if (filteredArticles.length === 0) {
		return null;
	}

	return (
		<ContentContainerStyled>
			<NewsContainer>
				<TitleAndLinkContainer>
					<RichTextTitle content={news.Values.Title} />
					<LinkContainer>
						<TextLinkWithArrow
							href={news.Values.CollectorPageLink.Url}
							title={news.Values.CollectorPageLink.Name}
						/>
					</LinkContainer>
				</TitleAndLinkContainer>
				<NewsSlider articles={filteredArticles.slice(0, NUMBER_OF_ARTICLES_TO_SHOW)} />
			</NewsContainer>
		</ContentContainerStyled>
	);
};

export default News;
